/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { ModalProps } from "./types";

export default CustomPlatform.select<() => React.FC<ModalProps>>({
  native: () => require("./Modal").default,
  web: () => require("./Modal.web").default,
  tv: () => require("./Modal.tv").default,
  default: () => () => null,
})();
